import { reactive } from 'vue'
import { Mutation, MutationMitRueckgabe } from './useOfflineQueue'

export const Kategorien = reactive([])
let KategorienGeladen = false

export async function KategorienLaden() {
  if (KategorienGeladen) return Kategorien
  const Antwort = await fetch('/backend/kategorienLaden.php', { credentials: 'include' })
  if (!Antwort.ok) return Kategorien
  const Daten = await Antwort.json()
  Kategorien.splice(0, Kategorien.length, ...Daten)
  KategorienGeladen = true
  return Kategorien
}

export async function KategorieHinzufuegen(Name) {
  const Daten = await MutationMitRueckgabe('/backend/kategorieHinzufuegen.php', { Name })
  Kategorien.push(Daten)
  return Daten
}

export function KategorieFinden(Id) {
  return Kategorien.find(k => k.Id === Id)
}

export async function KategorieAktualisieren(Id, Name) {
  const Kategorie = KategorieFinden(Id)
  const AlterName = Kategorie?.Name
  await Mutation(
    '/backend/kategorieAktualisieren.php',
    { Id, Name },
    () => { if (Kategorie) Kategorie.Name = Name },
    () => { if (Kategorie) Kategorie.Name = AlterName }
  )
}

export async function KategorieLoeschen(Id) {
  const Index = Kategorien.findIndex(k => k.Id === Id)
  const Sicherung = Index !== -1 ? { ...Kategorien[Index] } : null
  await Mutation(
    '/backend/kategorieLoeschen.php',
    { Id },
    () => { if (Index !== -1) Kategorien.splice(Index, 1) },
    () => { if (Sicherung !== null) Kategorien.splice(Index, 0, Sicherung) }
  )
}

export async function KategorienSortierenSpeichern() {
  Kategorien.forEach((Kategorie, Index) => { Kategorie.Reihenfolge = Index })
  const Reihenfolgen = Kategorien.map(k => ({ Id: k.Id, Reihenfolge: k.Reihenfolge }))
  await Mutation('/backend/kategorienSortierenSpeichern.php', { Reihenfolgen })
}

export const Zutaten = reactive([])
let ZutatenGeladen = false

export async function ZutatenLaden(Erzwingen = false) {
  if (ZutatenGeladen && !Erzwingen) return Zutaten
  const Antwort = await fetch('/backend/zutatenLaden.php', { credentials: 'include' })
  if (!Antwort.ok) return Zutaten
  const Daten = await Antwort.json()
  Zutaten.splice(0, Zutaten.length, ...Daten)
  ZutatenGeladen = true
  return Zutaten
}

export async function ZutatHinzufuegen({ Name, Menge, Einheit, KategorieId, Eingefroren }) {
  const Daten = await MutationMitRueckgabe('/backend/zutatHinzufuegen.php', { Name, Menge, Einheit, KategorieId, Eingefroren })
  Zutaten.push(Daten)
  return Daten
}

export function ZutatFinden(Id) {
  return Zutaten.find(z => z.Id === Id)
}

export async function ZutatAktualisieren(Id, Aenderungen) {
  const Zutat = ZutatFinden(Id)
  const Sicherung = Zutat ? { ...Zutat } : null
  await Mutation(
    '/backend/zutatAktualisieren.php',
    { Id, ...Aenderungen },
    () => { if (Zutat) Object.assign(Zutat, Aenderungen) },
    () => { if (Zutat && Sicherung) Object.assign(Zutat, Sicherung) }
  )
}

// BildDataUrl: JPEG-Data-URL zum Speichern, null zum Entfernen
export async function ZutatBildSpeichern(Id, BildDataUrl) {
  const Daten = await MutationMitRueckgabe('/backend/bildSpeichern.php', {
    Typ: 'Zutat',
    Id,
    ...(BildDataUrl === null ? { Entfernen: true } : { BildBase64: BildDataUrl })
  })
  const Zutat = ZutatFinden(Id)
  if (Zutat) {
    Zutat.HatBild = Daten.HatBild ? 1 : 0
    Zutat.BildVersion = Daten.BildVersion || null
  }
  return Daten
}

export async function ZutatLoeschen(Id) {
  const Index = Zutaten.findIndex(z => z.Id === Id)
  const Sicherung = Index !== -1 ? { ...Zutaten[Index] } : null
  await Mutation(
    '/backend/zutatLoeschen.php',
    { Id },
    () => { if (Index !== -1) Zutaten.splice(Index, 1) },
    () => { if (Sicherung !== null) Zutaten.splice(Index, 0, Sicherung) }
  )
}

/* ── Mehrere Einkaufslisten ─────────────────────────────
   Die aktive Liste bestimmt, welche Positionen die Ansichten zeigen.
   Sie wird pro Gerät gemerkt (localStorage), nicht pro Konto. */

const AKTIVE_LISTE_SCHLUESSEL = 'topfkucker_aktive_einkaufsliste'

export const Einkaufslisten = reactive([])
export const AktiveEinkaufsliste = reactive({ Id: null })
let EinkaufslistenGeladen = false

function AktiveListeSicherstellen() {
  const Gespeichert = Number(localStorage.getItem(AKTIVE_LISTE_SCHLUESSEL))
  if (Gespeichert && Einkaufslisten.some(l => l.Id === Gespeichert)) {
    AktiveEinkaufsliste.Id = Gespeichert
  } else if (!Einkaufslisten.some(l => l.Id === AktiveEinkaufsliste.Id)) {
    AktiveEinkaufsliste.Id = Einkaufslisten[0]?.Id ?? null
  }
}

export async function EinkaufslistenLaden() {
  if (EinkaufslistenGeladen) return Einkaufslisten
  const Antwort = await fetch('/backend/einkaufslistenLaden.php', { credentials: 'include' })
  if (!Antwort.ok) return Einkaufslisten
  const Daten = await Antwort.json()
  Einkaufslisten.splice(0, Einkaufslisten.length, ...Daten)
  EinkaufslistenGeladen = true
  AktiveListeSicherstellen()
  return Einkaufslisten
}

export function EinkaufslisteFinden(Id) {
  return Einkaufslisten.find(l => l.Id === Id)
}

export function AktiveEinkaufslisteSetzen(Id) {
  AktiveEinkaufsliste.Id = Id
  localStorage.setItem(AKTIVE_LISTE_SCHLUESSEL, String(Id))
}

export async function EinkaufslisteAnlegen(Name) {
  const Daten = await MutationMitRueckgabe('/backend/einkaufslisteAnlegen.php', { Name })
  Einkaufslisten.push(Daten)
  return Daten
}

export async function EinkaufslisteUmbenennen(Id, Name) {
  const Liste = EinkaufslisteFinden(Id)
  const AlterName = Liste?.Name
  await Mutation(
    '/backend/einkaufslisteUmbenennen.php',
    { Id, Name },
    () => { if (Liste) Liste.Name = Name },
    () => { if (Liste) Liste.Name = AlterName }
  )
}

export async function EinkaufslisteEntfernen(Id) {
  const Index = Einkaufslisten.findIndex(l => l.Id === Id)
  const Sicherung = Index !== -1 ? { ...Einkaufslisten[Index] } : null
  const EntferntePositionen = Einkaufslistenpositionen.filter(e => e.EinkaufslisteId === Id)
  await Mutation(
    '/backend/einkaufslisteLoeschen.php',
    { Id },
    () => {
      if (Index !== -1) Einkaufslisten.splice(Index, 1)
      for (let i = Einkaufslistenpositionen.length - 1; i >= 0; i--) {
        if (Einkaufslistenpositionen[i].EinkaufslisteId === Id) Einkaufslistenpositionen.splice(i, 1)
      }
      if (AktiveEinkaufsliste.Id === Id) AktiveListeSicherstellen()
    },
    () => {
      if (Sicherung !== null) Einkaufslisten.splice(Index, 0, Sicherung)
      Einkaufslistenpositionen.push(...EntferntePositionen)
    }
  )
}

export const Einkaufslistenpositionen = reactive([])
let EinkaufslisteGeladen = false

export async function EinkaufslisteLaden(Erzwingen = false) {
  if (EinkaufslisteGeladen && !Erzwingen) return Einkaufslistenpositionen
  const Antwort = await fetch('/backend/einkaufslisteLaden.php', { credentials: 'include' })
  if (!Antwort.ok) return Einkaufslistenpositionen
  const Daten = await Antwort.json()
  Einkaufslistenpositionen.splice(0, Einkaufslistenpositionen.length, ...Daten)
  EinkaufslisteGeladen = true
  return Einkaufslistenpositionen
}

// RezeptId: optional - wurde die Zutat automatisch wegen eines geplanten Rezepts hinzugefügt,
// vermerkt das Backend "Gehört zu diesem Rezept" (Daten.Quellen), angezeigt in der Einkaufsliste.
export async function ZutatZurEinkaufslisteHinzufuegen(ZutatId, EinkaufslisteId, Anzahl = 1, RezeptId = null) {
  const Daten = await MutationMitRueckgabe('/backend/einkaufslistenpositionHinzufuegen.php', { ZutatId, EinkaufslisteId, Anzahl, RezeptId })
  if (Daten.BereitsVorhanden) {
    // Server hat die Anzahl erhöht – lokalen Eintrag nachziehen
    const Eintrag = Einkaufslistenpositionen.find(e => e.Id === Daten.Id)
    if (Eintrag) {
      Eintrag.Anzahl = Daten.Anzahl
      Eintrag.Quellen = Daten.Quellen
    }
  } else {
    Einkaufslistenpositionen.push(Daten)
  }
  return Daten
}

export async function EinkaufslisteAusPlanungUebernehmen(Tage, EinkaufslisteId) {
  const Daten = await MutationMitRueckgabe('/backend/einkaufslisteAusPlanung.php', { Tage, EinkaufslisteId })
  for (const Position of Daten.Positionen || []) {
    const Eintrag = Einkaufslistenpositionen.find(e => e.Id === Position.Id)
    if (Eintrag) {
      Object.assign(Eintrag, Position)
    } else {
      Einkaufslistenpositionen.push(Position)
    }
  }
  return Daten
}

export async function EinkaufslistenpositionAnzahlAendern(Id, Anzahl) {
  if (Anzahl < 1) return
  const Eintrag = Einkaufslistenpositionen.find(e => e.Id === Id)
  const AlteAnzahl = Eintrag?.Anzahl
  await Mutation(
    '/backend/einkaufslistenpositionAktualisieren.php',
    { Id, Anzahl },
    () => { if (Eintrag) Eintrag.Anzahl = Anzahl },
    () => { if (Eintrag && AlteAnzahl !== undefined) Eintrag.Anzahl = AlteAnzahl }
  )
}

async function EinkaufslistenpositionGekauftSetzen(Id, Gekauft) {
  const Eintrag = Einkaufslistenpositionen.find(e => e.Id === Id)
  const AlterWert = Eintrag?.Gekauft
  const AlteGekauftAm = Eintrag?.GekauftAm
  await Mutation(
    '/backend/einkaufslistenpositionAktualisieren.php',
    { Id, Gekauft },
    () => { if (Eintrag) { Eintrag.Gekauft = Gekauft ? 1 : 0; Eintrag.GekauftAm = Gekauft ? new Date().toISOString() : null } },
    () => { if (Eintrag && AlterWert !== undefined) { Eintrag.Gekauft = AlterWert; Eintrag.GekauftAm = AlteGekauftAm } }
  )
}

export function EinkaufslistenEintragAlsGekauftMarkieren(Id) {
  return EinkaufslistenpositionGekauftSetzen(Id, true)
}

export function GekaufteZutatZurueckAufEinkaufsliste(Id) {
  return EinkaufslistenpositionGekauftSetzen(Id, false)
}

async function EinkaufslistenpositionEntfernen(Id) {
  const Index = Einkaufslistenpositionen.findIndex(e => e.Id === Id)
  const Sicherung = Index !== -1 ? { ...Einkaufslistenpositionen[Index] } : null
  await Mutation(
    '/backend/einkaufslistenpositionLoeschen.php',
    { Id },
    () => { if (Index !== -1) Einkaufslistenpositionen.splice(Index, 1) },
    () => { if (Sicherung !== null) Einkaufslistenpositionen.splice(Index, 0, Sicherung) }
  )
}

export const EinkaufslistenEintragEntfernen = EinkaufslistenpositionEntfernen
export const GekaufteZutatEntfernen = EinkaufslistenpositionEntfernen

async function EinkaufslistenpositionenLeeren(Gekauft, EinkaufslisteId) {
  const Betroffen = e => !!e.Gekauft === Gekauft && e.EinkaufslisteId === EinkaufslisteId
  const Entfernte = Einkaufslistenpositionen.filter(Betroffen)
  await Mutation(
    '/backend/einkaufslistenpositionenLeeren.php',
    { Gekauft, EinkaufslisteId },
    () => {
      for (let i = Einkaufslistenpositionen.length - 1; i >= 0; i--) {
        if (Betroffen(Einkaufslistenpositionen[i])) Einkaufslistenpositionen.splice(i, 1)
      }
    },
    () => { Einkaufslistenpositionen.push(...Entfernte) }
  )
}

export function EinkaufslisteLeeren(EinkaufslisteId) {
  return EinkaufslistenpositionenLeeren(false, EinkaufslisteId)
}

export function GekaufteZutatenLeeren(EinkaufslisteId) {
  return EinkaufslistenpositionenLeeren(true, EinkaufslisteId)
}

// Fuehrt Duplikate im Zutaten-Katalog zusammen: BehaltenId bleibt bestehen, ZutatIds werden
// entfernt, nachdem alle ihre Rezept-/Einkaufslisten-Verwendungen umgehaengt bzw. mit
// bestehenden Verwendungen der behaltenen Zutat zusammengefuehrt wurden (siehe Backend).
// Kein Mutation()-Offline-Queue-Eintrag, da die Auswirkungen (Loeschungen, umgehaengte
// Fremdschluessel in mehreren Tabellen) zu weitreichend fuer ein einfaches Rueckgaengig sind -
// stattdessen danach ein erzwungenes Neuladen der betroffenen Daten.
export async function ZutatenZusammenfuehren(BehaltenId, ZutatIds) {
  const Daten = await MutationMitRueckgabe('/backend/zutatenZusammenfuehren.php', { BehaltenId, ZutatIds })
  await Promise.all([ZutatenLaden(true), EinkaufslisteLaden(true)])
  return Daten
}
